import _extends from '@babel/runtime/helpers/extends';
import React__default, { useState, useRef } from 'react';
import styled, { css } from 'styled-components';
import { g as getUntabbablePills, a as getSurroundingFocusableElements } from './utils/index-PH3sRi3V.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { B as Button } from '../Button/Button-D3DP5nr7.js';
import { I as Icon } from '../Icon/Icon-CpzUnHit.js';
import { t as times } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-EM4gOTGb-B7bhIt-r.js';
import { K as KEYBOARD_KEYNAMES } from '../LocalModules/storm-ui-utils/dist/esm/keyboardKeynames-AmBipDtf-AmBipDtf.js';
import { P as Pill } from '../Pill/Pill-B5s3psMP.js';

const PillBoxWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30060407__sc-1o2y8n-0"
})(["display:flex;border:1px solid ", ";background:", ";overflow:auto;", ""], ({
  theme
}) => theme.palette.gray[300], ({
  theme
}) => theme.palette.gray[25], isMobile(css(["flex-direction:column-reverse;"])));
const InnerPillWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30060407__sc-1o2y8n-1"
})(["display:flex;flex-grow:1;flex-wrap:wrap;gap:10px;padding:10px;", ""], isMobile(css(["padding-top:0;"])));
const RemoveAllButtonWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30060407__sc-1o2y8n-2"
})(["width:max-content;", ""], isMobile(css(["width:100%;display:flex;justify-content:flex-end;"])));
const defaultRenderPill = ([key, pillProps]) => /*#__PURE__*/React__default.createElement(Pill, _extends({}, pillProps, {
  key: key
}));
const PillBox = props => {
  const {
    pills,
    removeAllLabel,
    onRemovePill,
    onRemoveAll,
    renderPill = defaultRenderPill,
    ...rest
  } = props;
  const [hasFocus, setHasFocus] = useState(false);
  const wrapperRef = useRef(null);
  const handleKeyDown = event => {
    const untabbablePills = getUntabbablePills(wrapperRef);
    const {
      previous,
      next
    } = getSurroundingFocusableElements(untabbablePills);
    if (event.key === KEYBOARD_KEYNAMES.ARROW_RIGHT || event.key === KEYBOARD_KEYNAMES.ARROW_DOWN) {
      if (next) {
        next.focus();
      } else {
        var _untabbablePills$at;
        (_untabbablePills$at = untabbablePills.at(0)) === null || _untabbablePills$at === void 0 || _untabbablePills$at.focus();
      }
    }
    if (event.key === KEYBOARD_KEYNAMES.ARROW_LEFT || event.key === KEYBOARD_KEYNAMES.ARROW_UP) {
      if (previous) {
        previous.focus();
      } else {
        var _untabbablePills$at2;
        (_untabbablePills$at2 = untabbablePills.at(-1)) === null || _untabbablePills$at2 === void 0 || _untabbablePills$at2.focus();
      }
    }
  };
  const handleFocus = event => {
    if (event.target === wrapperRef.current) {
      setHasFocus(true);
      getUntabbablePills(wrapperRef)[0].focus();
    }
  };
  const handleBlur = event => {
    const untabbablePills = getUntabbablePills(wrapperRef);
    if (event.relatedTarget && !untabbablePills.includes(event.relatedTarget)) {
      setHasFocus(false);
    }
  };
  return /*#__PURE__*/React__default.createElement(PillBoxWrapper, _extends({}, rest, {
    ref: wrapperRef,
    tabIndex: hasFocus ? -1 : 0,
    onFocus: handleFocus,
    onBlur: handleBlur
  }), /*#__PURE__*/React__default.createElement(InnerPillWrapper, null, pills === null || pills === void 0 ? void 0 : pills.map(pill => {
    const [key, pillProps] = pill;
    return renderPill([key, {
      ...pillProps,
      onKeyDown: handleKeyDown,
      key,
      onClose: event => onRemovePill === null || onRemovePill === void 0 ? void 0 : onRemovePill(event, pill),
      size: 'small',
      tabIndex: -1,
      closeLabel: `remove ${pillProps.label}`
    }]);
  })), /*#__PURE__*/React__default.createElement(RemoveAllButtonWrapper, null, pills && pills.length > 0 && /*#__PURE__*/React__default.createElement(Button, {
    transparent: true,
    onClick: onRemoveAll,
    "aria-label": removeAllLabel
  }, /*#__PURE__*/React__default.createElement(Icon, {
    type: times
  }))));
};
PillBox.defaultProps = {
  pills: [],
  onRemovePill: undefined,
  onRemoveAll: undefined,
  renderPill: undefined
};

export { PillBox as P };
//# sourceMappingURL=PillBox-CEerS0F0.js.map
